$(document).ready(function () {
  // ------------------- TB_category_featured Start -------------------
  var TB_category_featured = $(document).ready(function () {
            $("#TB-Category-featured .owl-carousel").owlCarousel({
                items: 6,
                loop: false,
                nav: false,
                dots: true,
                margin: 25,
                responsive: {
                    0: {
                        items: 1
                    },
                    500: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 3
                    },
                    1500: {
                        items: 3
                    }
                }
            });
        });
  // ------------------- TB_category_featured End -------------------

  $(document).ready(function () {
            var tb_services_cms = $("#TB-Bestseller-CMS .owl-carousel").owlCarousel({
                items: 4,
                nav: false,
                dots: true,
                loop: false,
                center: false,
                margin: 30,
                autoplayHoverPause: true,
                autoplay: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 1
                    },
                    768: {
                        items: 1
                    },
                    992: {
                        items: 1
                    },
                    1300: {
                        items: 1
                    }
                }
            });
        });
});
